export enum SequenceExportType {
    RawSequenceItem,
    ProcessedSequenceItem,
    PeakEvent,
    TamperEvent,
    SequenceEvent,
    AdminProcessedSequenceItem,
    ProcessorLogs,
}